'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var HANDLER_RETURN_VALUES = exports.HANDLER_RETURN_VALUES = {
    handled: 'handled',
    notHandled: 'not-handled'
};

// I think future versions of Draft JS will expose this.  When they do this should be removed.
var EditorChangeType = exports.EditorChangeType = {
    MOVE_SELECTION_TO_END_OF_BLOCK: 'move-selection-to-end-of-block',
    MOVE_SELECTION_TO_START_OF_BLOCK: 'move-selection-to-start-of-block',
    CHANGE_BLOCK_TYPE: 'change-block-type',
    CHANGE_INLINE_STYLE: 'change-inline-style',
    SPLIT_BLOCK: 'split-block'
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/draftjsConstants.js
// module id = 121
// module chunks = 0